import { render } from "./CompanyUsage.vue?vue&type=template&id=043b6c5c"
import script from "./CompanyUsage.vue?vue&type=script&lang=js"
export * from "./CompanyUsage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__